(function () {
  var T = window.TERES || {};
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var menu = $('[data-menu]');
  if (menu) menu.addEventListener('click', function () {
    var open = $('#nav').classList.toggle('open');
    menu.setAttribute('aria-expanded', open);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else { $$('[data-reveal]').forEach(function (el) { el.classList.add('in'); }); }

  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function addDays(n) { var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + n); return d; }
  var blocked = (T.blocked || []).map(function (s) { return s.trim(); }).filter(Boolean);
  var closed = (T.closedWeekdays || []).map(function (s) { return s.trim(); }).filter(Boolean);

  function dateProblem(value) {
    if (!value) return 'Choose a date.';
    var d = new Date(value + 'T12:00:00');
    if (iso(d) < iso(addDays(T.minDays || 0))) return 'We need at least ' + (T.minDays || 0) + ' days of notice. Text us for closer dates.';
    if (iso(d) > iso(addDays(T.maxDays || 365))) return 'That date is too far ahead. Text us to plan it.';
    if (closed.indexOf(String(d.getDay())) > -1) return 'We are closed that day. Pick another date.';
    if (blocked.indexOf(value) > -1) return 'That date is booked. Pick another date or text us.';
    return '';
  }
  function wireDate(input) {
    if (!input) return null;
    input.min = iso(addDays(T.minDays || 0));
    input.max = iso(addDays(T.maxDays || 365));
    var box = input.closest('.field');
    var err = box && $('[data-date-error]', box);
    function check() {
      var msg = input.value ? dateProblem(input.value) : '';
      if (err) { err.hidden = !msg; err.textContent = msg; }
      return msg;
    }
    input.addEventListener('change', check);
    return function () { var m = dateProblem(input.value); if (err) { err.hidden = !m; err.textContent = m; } return m; };
  }

  var root = $('[data-product]');
  if (root) {
    var form = $('#product-form');
    var variantId = $('[data-variant-id]', form);
    var priceLabel = $('[data-price-label]');
    var addLabel = $('[data-add-label]');
    var formErr = $('[data-form-error]', form);
    var area = $('#delivery-area');
    var checkDate = wireDate($('[data-date]', form));

    function selectedVariant() { return $('input[name=variant]:checked', form); }
    function fulfillment() { var r = $('input[name=fulfillment]:checked', form); return r ? r.value : 'Pickup'; }
    function total() {
      var v = selectedVariant(), cents = v ? +v.dataset.price : null;
      if (cents === null) return null;
      if (fulfillment() === 'Delivery' && area && area.selectedOptions[0] && area.value) cents += +area.selectedOptions[0].dataset.price;
      return cents;
    }
    function refresh() {
      var v = selectedVariant();
      if (v) { variantId.value = v.value; priceLabel.textContent = money.format(+v.dataset.price / 100); }
      $$('[data-delivery-field]', form).forEach(function (el) { el.hidden = fulfillment() !== 'Delivery'; });
      var t = total();
      if (t !== null && !$('[data-add]', form).disabled) addLabel.textContent = 'Add to cart · ' + money.format(t / 100);
    }
    form.addEventListener('change', refresh);
    refresh();

    $$('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        $('#main-img').src = b.dataset.thumb;
        $$('[data-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      formErr.hidden = true;
      var problem = '';
      if (root.dataset.needsDate === 'true') {
        problem = checkDate && checkDate();
        if (!problem && fulfillment() === 'Delivery') {
          if (area && !area.value) problem = 'Choose your delivery area.';
          else if (!$('#addr').value.trim()) problem = 'Enter the delivery address.';
        }
      }
      if (problem) { formErr.textContent = problem; formErr.hidden = false; return; }

      var props = {};
      new FormData(form).forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(val).trim()) props[m[1]] = String(val).trim();
      });
      if (root.dataset.needsDate === 'true') props['Fulfillment'] = fulfillment();
      var items = [{ id: +variantId.value, quantity: 1, properties: props }];
      if (fulfillment() === 'Delivery' && area && area.value) {
        items.push({ id: +area.value, quantity: 1, properties: { 'Delivery for': $('[data-date]', form).value } });
      }
      var btn = $('[data-add]', form); btn.disabled = true; addLabel.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; refresh(); formErr.textContent = 'Could not add that to your cart. Please try again or text us.'; formErr.hidden = false; });
    });
  }

  var b = $('[data-builder]');
  if (b) {
    var steps = $$('[data-step]', b), bars = $$('.progress li', b), i = 0;
    var next = $('[data-next]', b), back = $('[data-back]', b), submit = $('[data-submit]', b), err = $('[data-form-error]', b);
    var f = $('form', b), storeKey = 'teres-quote';
    var checkQ = wireDate($('[data-date]', b));
    if (!f || !steps.length) return;
    try {
      var saved = JSON.parse(localStorage.getItem(storeKey) || '{}');
      Object.keys(saved).forEach(function (k) {
        var els = f.elements[k]; if (!els) return;
        if (els.length && els[0] && els[0].type === 'radio') { $$('input[name="' + k + '"]', f).forEach(function (r) { r.checked = r.value === saved[k]; }); }
        else if (els.type !== 'hidden') els.value = saved[k];
      });
    } catch (x) {}
    f.addEventListener('input', function () {
      try { var o = {}; new FormData(f).forEach(function (v, k) { if (k.indexOf('contact[') === 0 && k.indexOf('email') < 0 && k.indexOf('Phone') < 0 && k.indexOf('name]') < 0) o[k] = v; }); localStorage.setItem(storeKey, JSON.stringify(o)); } catch (x) {}
    });
    function show() {
      steps.forEach(function (s, n) { s.classList.toggle('on', n === i); });
      bars.forEach(function (p, n) { p.classList.toggle('on', n <= i); });
      back.hidden = i === 0; next.hidden = i === steps.length - 1; submit.hidden = i !== steps.length - 1;
      err.hidden = true;
      steps[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    function validStep() {
      var bad = '';
      $$('[required]', steps[i]).forEach(function (el) {
        if (bad) return;
        if (el.type === 'radio') { if (!$('input[name="' + el.name + '"]:checked', steps[i])) bad = 'Choose an option to continue.'; }
        else if (!el.value.trim()) bad = 'Fill in the required fields to continue.';
      });
      if (!bad && $('[data-date]', steps[i])) bad = checkQ();
      if (bad) { err.textContent = bad; err.hidden = false; return false; }
      return true;
    }
    next.addEventListener('click', function () { if (validStep()) { i++; show(); } });
    back.addEventListener('click', function () { i--; show(); });
    f.addEventListener('submit', function (e) {
      if (!validStep()) { e.preventDefault(); return; }
      try { localStorage.removeItem(storeKey); } catch (x) {}
    });
    show();
  }
})();
